/**
 * Generated from ch6_p10.fla
 */
export function ch6_p10(this: Ich6_p10) {
	const texture = this.texture;
	if (!texture[0] && texture.elementFactory) {
		texture[0] = texture.elementFactory(0,undefined);
	}
	if (texture[0]) {
		ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer241.call(texture[0] as Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer241);
		texture[0].x = 832;
		texture[0].y = 384;
		texture[0].width = 1664.00;
		texture[0].height = 768.00;
		texture[0].alpha = 1;
		if (texture[0].onLayout) texture[0].onLayout();
	}
	if (!texture[1] && texture.elementFactory) {
		texture[1] = texture.elementFactory(1,undefined);
	}
	if (texture[1]) {
		ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer9copy.call(texture[1] as Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer9copy);
		texture[1].x = 832;
		texture[1].y = 384;
		texture[1].width = 1664.00;
		texture[1].height = 768.00;
		texture[1].alpha = 1;
		if (texture[1].onLayout) texture[1].onLayout();
	}
	const bg = this.bg;
	ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const cupcakeRight = this.cupcakeRight;
	ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_l.call(this.cupcakeRight);
	cupcakeRight.x = 831;
	cupcakeRight.y = 432.25;
	cupcakeRight.width = 348.00;
	cupcakeRight.height = 396.50;
	cupcakeRight.alpha = 1.00;
	if (cupcakeRight.onLayout) cupcakeRight.onLayout();
	const cupcakeLeft = this.cupcakeLeft;
	ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_r.call(this.cupcakeLeft);
	cupcakeLeft.x = 809.25;
	cupcakeLeft.y = 388;
	cupcakeLeft.width = 385.50;
	cupcakeLeft.height = 479.00;
	cupcakeLeft.alpha = 1.00;
	if (cupcakeLeft.onLayout) cupcakeLeft.onLayout();
	const cupcakeLeftCut = this.cupcakeLeftCut;
	ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_rstroke.call(this.cupcakeLeftCut);
	cupcakeLeftCut.x = 809.25;
	cupcakeLeftCut.y = 388;
	cupcakeLeftCut.width = 385.50;
	cupcakeLeftCut.height = 479.00;
	cupcakeLeftCut.alpha = 1.00;
	if (cupcakeLeftCut.onLayout) cupcakeLeftCut.onLayout();
	const frameRight = this.frameRight;
	ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 357.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 339.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_bg(this: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p10_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_l(this: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_l) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p10_l", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_r(this: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_r) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p10_r", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_rstroke(this: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_rstroke) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p10_rstroke", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer241(this: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer241) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer241", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer9copy(this: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer9copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer9copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeRframe(this: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeLframe(this: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich6_p10Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p10Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p10Sprite extends Ich6_p10Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p10Text extends Ich6_p10Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p10Polygon extends Array<number> {
}
interface Ich6_p10 {
	readonly texture: Ich6_p10Array<Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer241|Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer9copy>;
	readonly bg: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_bg;
	readonly cupcakeRight: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_l;
	readonly cupcakeLeft: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_r;
	readonly cupcakeLeftCut: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_rstroke;
	readonly frameRight: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeRframe;
	readonly frameLeft: Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeLframe;
}
interface Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_bg extends Ich6_p10Sprite {
}
interface Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_l extends Ich6_p10Sprite {
}
interface Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_r extends Ich6_p10Sprite {
}
interface Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_rstroke extends Ich6_p10Sprite {
}
interface Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer241 extends Ich6_p10Sprite {
}
interface Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframetextureLayer9copy extends Ich6_p10Sprite {
}
interface Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeRframe extends Ich6_p10Sprite {
}
interface Ich6_p10_hh_ch6_72dpi_p10psdAssetchp6_p10_wcframeLframe extends Ich6_p10Sprite {
}
